// extracted by mini-css-extract-plugin
export default {"Instructions":"ak2Ss7Eg"};